import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import PropTypes from 'prop-types';
import Cookie from 'utils/cookies';
import s from './HowToPlay.scss';
import Image from '../../../../../components/Image';
import { TOI_IMAGE_DOMAIN } from '../../../../../constants';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

const HowToPlay = props => {
  const { gameType, isMobile, theme, isAppView, gaLevel } = props;
  const grxId = Cookie.get('_grx') || '';
  const ssoId = Cookie.get('ssoid') || '';

  useEffect(
    () => {
      const gaData = {
        event: 'user_shown_games',
        type: 'how_to_play',
        page_template: 'gameplay',
        section: 'games',
        subsection: gameType === 'loopaloop' ? 'loop_the_loop' : gameType,
        browsing_platform: isMobile ? 'mweb' : 'web',
        level: gaLevel,
        game_of_the_day: window.location.href.toLowerCase().includes('/today'),
        login_status: !!ssoId,
        user_grx_id: grxId,
      };
      if (ssoId) {
        gaData.sso_id = ssoId;
      }
      analyticsWrapper('ga4', gaData);
      analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
    },
    [gameType],
  );

  const translations = _get(props, 'gamesconfigData.translations', {});

  const getHowToPlayInstructions = () => {
    if (!translations) {
      return null;
    }
    switch (gameType) {
      case 'crossword':
        if (
          translations?.howToPlayScreenTranslations?.howToPlayTextForCrossWord
        ) {
          return (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  translations?.howToPlayScreenTranslations
                    ?.howToPlayTextForCrossWord,
              }}
            />
          );
        }
        return null;
      case 'sudoku':
        if (translations?.howToPlayScreenTranslations?.howToPlayTextForSudoku) {
          return (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  translations?.howToPlayScreenTranslations
                    ?.howToPlayTextForSudoku,
              }}
            />
          );
        }
        return null;
      case 'mini-crossword':
        if (
          translations?.howToPlayScreenTranslations
            ?.howToPlayTextForMiniCrossWord
        ) {
          return (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  translations?.howToPlayScreenTranslations
                    ?.howToPlayTextForMiniCrossWord,
              }}
            />
          );
        }
        return null;
      case 'location-guesser':
        if (
          translations?.howToPlayScreenTranslations
            ?.howToPlayTextForLocationGuesser
        ) {
          return (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  translations?.howToPlayScreenTranslations
                    ?.howToPlayTextForLocationGuesser,
              }}
            />
          );
        }
        return null;
      default:
        return null;
    }
  };

  return (
    <>
      <div
        className={`${s.howPlayInnerArea} ${
          gameType === 'loopaloop' ? s.loopInnerArea : ''
        } ${
          gameType === 'loopaloop' && theme === 'dark'
            ? s.loopInnerAreaDarkTheme
            : ''
        } ${
          gameType === 'loopaloop' && theme === 'light'
            ? s.loopInnerAreaLightTheme
            : ''
        }
        ${
          gameType === 'loopaloop' && (theme === 'light' || theme === 'dark')
            ? s.loopInnerAreaAppView
            : ''
        } ${gameType === 'whos-that' ? s.whosInnerArea : ''}`}
      >
        {gameType === 'sudoku' && (
          <div className={`${s.filledRevealed} ${s.seperator}`}>
            <div className={s.filled}>
              <h4>
                {translations?.commonTranslations?.sections?.preFilled ||
                  'Pre-filled:'}
              </h4>
              <div className={s.square}>1</div>
            </div>
            <div className={s.revealed}>
              <h4>
                {translations?.commonTranslations?.sections?.revealed ||
                  'Revealed:'}
              </h4>
              <div className={s.square}>1</div>
            </div>
          </div>
        )}
        {gameType === 'mini_crossword' ||
          (gameType === 'crossword' && (
            <div className={`${s.acrossDown} ${s.seperator}`}>
              <div className={s.across}>
                <h4>
                  {translations?.commonTranslations?.sections?.across ||
                    'Across:'}
                </h4>
                <ul>
                  <li>
                    <span>1</span>
                    <strong>A</strong>
                  </li>
                  <li>
                    <span>2</span>
                  </li>
                  <li>
                    <span>3</span>
                  </li>
                </ul>
              </div>
              <div className={s.down}>
                <h4>
                  {translations?.commonTranslations?.sections?.down || 'Down:'}
                </h4>
                <ul>
                  <li>
                    <span>1</span>
                    <strong>A</strong>
                  </li>
                  <li>
                    <span>14</span>
                  </li>
                  <li>
                    <span>17</span>
                  </li>
                </ul>
              </div>
              <div className={s.revealed}>
                <h4>
                  {translations?.commonTranslations?.sections?.revealed ||
                    'Revealed:'}
                </h4>
                <ul>
                  <li>
                    <strong>A</strong>
                  </li>
                </ul>
              </div>
            </div>
          ))}
        <div className={`${s.helpbar} ${s.seperator} `}>
          <div className={s.subTitle}>
            <h3>
              {translations?.commonTranslations?.sections?.helpBar ||
                'Help Bar:'}
            </h3>
          </div>
          {gameType !== 'location-guesser' &&
            gameType !== 'loopaloop' &&
            gameType !== 'whos-that' && (
              <>
                <div className={s.timeBlock}>
                  <div className={s.left}>
                    <strong>10:31</strong>
                  </div>
                  <div className={s.right}>
                    <ul>
                      <li>
                        <i className={`${s.icon} ${s.question}`} />
                      </li>
                      <li>
                        <i className={`${s.icon} ${s.reveal}`} />
                      </li>
                      <li>
                        <i className={`${s.icon} ${s.dots}`} />
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={s.helpOptions}>
                  <ul>
                    <li>
                      <div>
                        <strong>10:31</strong>
                      </div>
                      <span>
                        {translations?.commonTranslations?.helpOptions?.timer
                          ?.on || 'Timer:'}
                      </span>
                    </li>
                    <li>
                      <div className={s.iconCircle}>
                        <i className={`${s.icon} ${s.question}`} />
                      </div>
                      <span>
                        {translations?.commonTranslations?.helpOptions
                          ?.howToPlay || 'How to play'}
                      </span>
                    </li>
                    <li>
                      <div className={s.iconCircle}>
                        <i className={`${s.icon} ${s.reveal}`} />
                      </div>
                      {/* <span>Reveal Character</span> */}
                      <span>
                        {translations?.commonTranslations?.helpOptions
                          ?.revealDigit || 'Reveal digit'}
                      </span>
                    </li>
                    <li>
                      <div className={s.iconCircle}>
                        <i className={`${s.icon} ${s.dots}`} />
                      </div>
                      <span>
                        {translations?.commonTranslations?.helpOptions
                          ?.otherOptions || 'Other options'}
                      </span>
                    </li>
                  </ul>
                </div>
              </>
            )}
          {gameType === 'location-guesser' && (
            <div className={s.locationGuesserHelp}>
              <div className={s.timeBlock}>
                <div className={s.roundCircle}>
                  <i className={`${s.locationGuesserSprite} ${s.backArrow}`} />
                </div>
                <div className={s.right}>
                  <ul>
                    <li>
                      <i className={`${s.locationGuesserSprite} ${s.help}`} />
                    </li>
                    <li>
                      <i className={`${s.locationGuesserSprite} ${s.replay}`} />
                    </li>
                    <li>
                      <i className={`${s.locationGuesserSprite} ${s.unMute}`} />
                    </li>
                  </ul>
                </div>
              </div>
              <div className={s.helpOptions}>
                <ul>
                  <li>
                    <div className={s.iconCircle}>
                      <i
                        className={`${s.locationGuesserSprite} ${s.backArrow}`}
                      />
                    </div>
                    <span>
                      {translations?.commonTranslations?.helpOptions?.goBack ||
                        'Go back'}
                    </span>
                  </li>
                  <li>
                    <div className={s.iconCircle}>
                      <i className={`${s.locationGuesserSprite} ${s.help}`} />
                    </div>
                    <span>
                      {translations?.commonTranslations?.helpOptions
                        ?.howToPlay || 'How to play'}
                    </span>
                  </li>
                  <li>
                    <div className={s.iconCircle}>
                      <i className={`${s.locationGuesserSprite} ${s.remind}`} />
                    </div>
                    <span>
                      {translations?.commonTranslations?.helpOptions
                        ?.backward || '10s Backward'}
                    </span>
                  </li>
                  <li>
                    <div className={s.iconCircle}>
                      <i
                        className={`${s.locationGuesserSprite} ${s.forward}`}
                      />
                    </div>
                    <span>
                      {translations?.commonTranslations?.helpOptions?.forward ||
                        '10s Forward'}
                    </span>
                  </li>
                  <li>
                    <div className={s.iconCircle}>
                      <i className={`${s.locationGuesserSprite} ${s.mute}`} />
                    </div>
                    <span>
                      {translations?.commonTranslations?.helpOptions?.unmute ||
                        'unmute'}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {gameType === 'loopaloop' && (
            <>
              <div className={`${s.timeBlock} ${s.loopTimeBlock}`}>
                <div className={s.left}>
                  <strong>10:31</strong>
                </div>
                <div className={s.right}>
                  <ul>
                    {!isAppView && (
                      <>
                        <li>
                          <i className={`${s.icon} ${s.timer}`} />
                          <div className={s.switch}>
                            <span>
                              {translations?.gameSpecificTranslations?.loopALoop
                                ?.timer?.on || 'On'}
                            </span>
                          </div>
                        </li>
                        <li>
                          <i className={`${s.icon} ${s.pause}`} />
                        </li>
                      </>
                    )}
                    <li>
                      <i className={`${s.icon} ${s.reset}`} />
                    </li>
                    {isAppView && (
                      <li>
                        <i className={`${s.icon} ${s.question}`} />
                      </li>
                    )}
                  </ul>
                </div>
              </div>
              <div className={`${s.helpOptions} ${s.loopHelpOptions}`}>
                <ul>
                  {!isAppView && (
                    <>
                      <li>
                        <div className={s.iconCircle}>
                          <i className={`${s.icon} ${s.timer}`} />
                        </div>
                        <span>
                          {translations?.commonTranslations?.helpOptions
                            ?.timer || 'Timer'}
                        </span>
                      </li>
                      <li>
                        <div className={s.iconCircle}>
                          <i className={`${s.icon} ${s.pause}`} />
                        </div>
                        <span>
                          {translations?.commonTranslations?.helpOptions
                            ?.pause || 'Pause'}
                        </span>
                      </li>
                    </>
                  )}
                  <li>
                    <div className={s.iconCircle}>
                      <i className={`${s.icon} ${s.reset}`} />
                    </div>
                    <span>
                      {translations?.commonTranslations?.helpOptions?.reset ||
                        'Reset'}
                    </span>
                  </li>
                  {isMobile && (
                    <li>
                      <div className={s.iconCircle}>
                        <i className={`${s.icon} ${s.question}`} />
                      </div>
                      <span>
                        {translations?.commonTranslations?.helpOptions
                          ?.howToPlay || 'How to play'}
                      </span>
                    </li>
                  )}
                </ul>
              </div>
            </>
          )}
          {gameType === 'whos-that' && (
            <>
              <div className={`${s.timeBlock} ${s.whosTimeBlock}`}>
                <div className={s.roundWrap}>
                  <ul>
                    <li>
                      <div className={s.itemTop}>
                        <span>P1</span>
                      </div>
                      <div className={s.itemBottom}>
                        <strong>-</strong>
                      </div>
                    </li>
                    <li>
                      <div className={s.itemTop}>
                        <span>P2</span>
                      </div>
                      <div className={s.itemBottom}>
                        <strong>-</strong>
                      </div>
                    </li>
                    <li>
                      <div className={s.itemTop}>
                        <span>P3</span>
                      </div>
                      <div className={s.itemBottom}>
                        <strong>-</strong>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className={s.right}>
                  <ul>
                    <li>
                      <i className={`${s.icon} ${s.reveal}`} />
                    </li>
                    <li>
                      <i className={`${s.icon} ${s.pause}`} />
                    </li>
                    <li>
                      <i className={`${s.icon} ${s.question}`} />
                    </li>
                  </ul>
                </div>
              </div>
              <div className={`${s.helpOptions} ${s.whosHelpOptions}`}>
                <ul>
                  <li>
                    <div className={s.iconCircle}>
                      <i className={`${s.icon} ${s.reveal}`} />
                    </div>
                    <span>
                      {translations?.commonTranslations?.helpOptions?.reveal ||
                        'Reveal'}
                    </span>
                  </li>
                  <li>
                    <div className={s.iconCircle}>
                      <i className={`${s.icon} ${s.pause}`} />
                    </div>
                    <span>
                      {translations?.commonTranslations?.helpOptions?.pause ||
                        'Pause'}
                    </span>
                  </li>
                  <li>
                    <div className={s.iconCircle}>
                      <i className={`${s.icon} ${s.question}`} />
                    </div>
                    <span>
                      {translations?.commonTranslations?.helpOptions
                        ?.howToPlay || 'How to play'}
                    </span>
                  </li>
                </ul>
              </div>
            </>
          )}
        </div>
        {gameType === 'whos-that' && (
          <>
            <div className={`${s.whosContent}`}>
              <ul>
                <li>
                  <h3>
                    {translations?.gameSpecificTranslations?.whosThat
                      ?.getGoing || '1. Get going'}
                  </h3>
                  <p>
                    {translations?.gameSpecificTranslations?.whosThat
                      ?.paragraphs?.getGoing ||
                      'Take a moment to familiarize yourself with the challenge and get ready to put your cricket knowledge to the test.'}
                  </p>
                </li>
                <li>
                  <h3>
                    {translations?.gameSpecificTranslations?.whosThat
                      ?.understandChallenge || '2. Understand the Challenge'}
                  </h3>
                  <p>
                    {translations?.gameSpecificTranslations?.whosThat
                      ?.paragraphs?.understandChallenge ||
                      'Challenge yourself daily with 3 exciting player guesses! For every player, you&apos;ll have 6 chances to crack the code and identify the cricketer.'}
                  </p>
                </li>
                <li>
                  <h3>
                    {translations?.gameSpecificTranslations?.whosThat
                      ?.makeGuess || '3. Make Your Guess'}
                  </h3>
                  <p>
                    {translations?.gameSpecificTranslations?.whosThat
                      ?.paragraphs?.makeGuess ||
                      `Start typing your answer in the &apos;Guess the Player&apos; input box—helpful suggestions will pop up as you go. Ready to lock in your pick? Hit the 'Guess' button and see if you've scored the right answer!`}
                  </p>
                </li>
                <li>
                  <h3>
                    {translations?.gameSpecificTranslations?.whosThat
                      ?.revealNavigate || `4. Reveal and Navigate`}
                  </h3>
                  <p>
                    {translations?.gameSpecificTranslations?.whosThat
                      ?.paragraphs?.revealNavigate ||
                      `Use the Reveal feature to show the player&apos;s name, but it will result in zero points for that player. Also, seamlessly switch between players using the navigation controls to keep the challenge going!`}
                  </p>
                </li>
                <li>
                  <h3>
                    {translations?.gameSpecificTranslations?.whosThat
                      ?.hintsChances || '5. Hints & Chances'}
                  </h3>
                  <p>
                    {translations?.gameSpecificTranslations?.whosThat
                      ?.paragraphs?.hintsChances ||
                      `Each incorrect guess unveils one of the 5 available hints, deducts 10 points from the maximum possible score, and reduces your remaining chances—so choose your answers wisely!`}
                  </p>
                </li>
                <li>
                  <h3>
                    {
                      translations?.gameSpecificTranslations?.whosThat
                        ?.scoringMechanism
                    }
                  </h3>
                  {translations?.gameSpecificTranslations?.whosThat?.paragraphs?.scoringMechanism?.map(
                    (text, index) => <p key={index}>{text}</p>,
                  )}
                </li>
                <li>
                  <h3>
                    {
                      translations?.gameSpecificTranslations?.whosThat
                        ?.keepPlaying
                    }
                  </h3>
                  <p>
                    {
                      translations?.gameSpecificTranslations?.whosThat
                        ?.paragraphs?.keepPlaying
                    }
                  </p>
                </li>
              </ul>
            </div>
          </>
        )}

        {gameType !== 'location-guesser' &&
          gameType !== 'loopaloop' &&
          gameType !== 'whos-that' && (
            <div className={`${s.menu} ${s.seperator}`}>
              <div className={s.subTitle}>
                <h3>{translations?.commonTranslations?.sections?.menu}</h3>
              </div>
              <ul className={s.menuList}>
                <li>
                  <div className={s.iconWrap}>
                    <i className={`${s.icon} ${s.revealCharacter}`} />
                  </div>
                  <span>
                    {translations?.commonTranslations?.helpOptions?.revealDigit}
                  </span>
                </li>
                <li>
                  <div className={s.iconWrap}>
                    <i className={`${s.icon} ${s.revealPuzzle}`} />
                  </div>
                  {/* <span>Reveal Puzzle (+ 60 sec) *</span> */}
                  <span>
                    {
                      translations?.commonTranslations?.helpOptions
                        ?.revealPuzzle
                    }
                  </span>
                </li>
                <li>
                  <div className={s.iconWrap}>
                    <i className={`${s.icon} ${s.reset}`} />
                  </div>
                  <span>
                    {translations?.commonTranslations?.helpOptions?.reset}
                  </span>
                </li>
                <li>
                  <div className={s.iconWrap}>
                    <i className={`${s.icon} ${s.question}`} />
                  </div>
                  <span>
                    {translations?.commonTranslations?.helpOptions?.howToPlay}
                  </span>
                </li>
              </ul>
              <div className={s.noteArea}>
                <strong>Note:</strong>
                <ul>
                  {/* <li>
                Each revealed character adds a 5-second penalty incrementally
              </li>
              <li>
                Revealing puzzle adds a cumulative 5-second incremental penalty
                for all the blank and incorrectly filled cells
              </li> */}
                  <li>
                    {translations?.commonTranslations?.notes?.revealDigit}
                  </li>
                  <li>
                    {translations?.commonTranslations?.notes?.revealPuzzle}
                  </li>
                </ul>
              </div>
            </div>
          )}

        {gameType === 'loopaloop' && (
          <>
            <div className={s.loopaloopHelp}>
              <div className={`${s.seperator} ${s.blueBg}`}>
                <div className={s.subTitle}>
                  <h3>
                    {translations?.commonTranslations?.sections?.objective ||
                      `Objective:`}
                  </h3>
                </div>
                <p>
                  {translations?.gameSpecificTranslations?.loopALoop
                    ?.objective ||
                    `Create a single, continuous loop that connects adjacent dots and encloses the grid.`}
                </p>
                <figure>
                  <Image
                    src={`${TOI_IMAGE_DOMAIN}/photo/${
                      theme === 'dark' ? '118198196' : '118109875'
                    }.cms`}
                    alt="loop the loop"
                  />
                </figure>
              </div>
              <div className={`${s.seperator}`}>
                <div className={s.subTitle}>
                  <h3>
                    {translations?.commonTranslations?.sections?.rules ||
                      `Rules`}
                  </h3>
                </div>

                <p>
                  {
                    translations?.gameSpecificTranslations?.loopALoop?.rules
                      ?.rule1
                  }
                </p>

                <figure>
                  <Image
                    src={`${TOI_IMAGE_DOMAIN}/photo/${
                      theme === 'dark' ? '118198194' : '118109873'
                    }.cms`}
                    alt="loop the loop"
                  />
                </figure>
              </div>
              <div className={`${s.seperator} ${s.blueBg}`}>
                <p>
                  {
                    translations?.gameSpecificTranslations?.loopALoop?.rules
                      ?.rule2
                  }
                </p>
                <div className={s.threeColumn}>
                  <figure>
                    <Image
                      src={`${TOI_IMAGE_DOMAIN}/photo/${
                        theme === 'dark' ? '118198191' : '118109870'
                      }.cms`}
                      alt="loop the loop"
                    />
                  </figure>
                  <figure>
                    <Image
                      src={`${TOI_IMAGE_DOMAIN}/photo/${
                        theme === 'dark' ? '118198189' : '118109864'
                      }.cms`}
                      alt="loop the loop"
                    />
                  </figure>
                  <figure>
                    <Image
                      src={`${TOI_IMAGE_DOMAIN}/photo/${
                        theme === 'dark' ? '118198186' : '118109858'
                      }.cms`}
                      alt="loop the loop"
                    />
                  </figure>
                </div>
              </div>
              <div className={`${s.seperator}`}>
                <p>
                  {
                    translations?.gameSpecificTranslations?.loopALoop?.rules
                      ?.rule3
                  }
                </p>
                <div className={s.threeColumn}>
                  <figure>
                    <Image
                      src={`${TOI_IMAGE_DOMAIN}/photo/${
                        theme === 'dark' ? '118198184' : '118125334'
                      }.cms`}
                      alt="loop the loop"
                    />
                  </figure>
                </div>
              </div>
              <div className={`${s.seperator} ${s.blueBg}`}>
                <p>
                  {
                    translations?.gameSpecificTranslations?.loopALoop?.rules
                      ?.rule4
                  }
                </p>
                <div className={s.threeColumn}>
                  <figure>
                    <Image
                      src={`${TOI_IMAGE_DOMAIN}/photo/${
                        theme === 'dark' ? '118198182' : '118109852'
                      }.cms`}
                      alt="loop the loop"
                    />
                  </figure>
                  <figure>
                    <Image
                      src={`${TOI_IMAGE_DOMAIN}/photo/${
                        theme === 'dark' ? '118198181' : '118109848'
                      }.cms`}
                      alt="loop the loop"
                    />
                  </figure>
                  <figure>
                    <Image
                      src={`${TOI_IMAGE_DOMAIN}/photo/${
                        theme === 'dark' ? '118198179' : '118109848'
                      }.cms`}
                      alt="loop the loop"
                    />
                  </figure>
                </div>
              </div>
              <div className={`${s.seperator}`}>
                <p>
                  {
                    translations?.gameSpecificTranslations?.loopALoop?.rules
                      ?.rule5
                  }
                </p>
                <div className={s.threeColumn}>
                  <figure>
                    <Image
                      src={`${TOI_IMAGE_DOMAIN}/photo/${
                        theme === 'dark' ? '118198177' : '118109841'
                      }.cms`}
                      alt="loop the loop"
                    />
                  </figure>
                  <figure>
                    <Image
                      src={`${TOI_IMAGE_DOMAIN}/photo/${
                        theme === 'dark' ? '118198176' : '118109839'
                      }.cms`}
                      alt="loop the loop"
                    />
                  </figure>
                  <figure>
                    <Image
                      src={`${TOI_IMAGE_DOMAIN}/photo/${
                        theme === 'dark' ? '118198174' : '118109835'
                      }.cms`}
                      alt="loop the loop"
                    />
                  </figure>
                </div>
              </div>
              <div className={`${s.seperator} ${s.blueBg}`}>
                <div className={s.subTitle}>
                  <h3>
                    {
                      translations?.commonTranslations?.sections
                        ?.whatIsNotAllowed
                    }
                  </h3>
                </div>
                <div className={s.threeColumn}>
                  <figure>
                    <Image
                      src={`${TOI_IMAGE_DOMAIN}/photo/${
                        theme === 'dark' ? '118198173' : '118109831'
                      }.cms`}
                      alt="loop the loop"
                    />
                  </figure>
                  <figure>
                    <Image
                      src={`${TOI_IMAGE_DOMAIN}/photo/${
                        theme === 'dark' ? '118198172' : '118109828'
                      }.cms`}
                      alt="loop the loop"
                    />
                  </figure>
                  <figure>
                    <Image
                      src={`${TOI_IMAGE_DOMAIN}/photo/${
                        theme === 'dark' ? '118198170' : '118109826'
                      }.cms`}
                      alt="loop the loop"
                    />
                  </figure>
                </div>
              </div>
              <div className={`${s.seperator}`}>
                <div className={s.subTitle}>
                  <h3>
                    {translations?.commonTranslations?.sections?.autoCheck}
                  </h3>
                </div>
                <p>
                  {
                    translations?.gameSpecificTranslations?.loopALoop?.autoCheck
                      ?.description
                  }
                </p>
                <div className={s.checkBox}>
                  <div className={s.item}>
                    <span>
                      {
                        translations?.gameSpecificTranslations?.loopALoop
                          ?.autoCheck?.on
                      }
                    </span>
                    <i className={`${s.tick}`} />
                  </div>
                  <div className={s.item}>
                    <span>
                      {
                        translations?.gameSpecificTranslations?.loopALoop
                          ?.autoCheck?.off
                      }
                    </span>
                    <i className={`${s.unTick}`} />
                  </div>
                </div>
                <p>
                  {
                    translations?.gameSpecificTranslations?.loopALoop?.autoCheck
                      ?.result
                  }
                </p>
                <figure>
                  <Image
                    src={`${TOI_IMAGE_DOMAIN}/photo/${
                      theme === 'dark' ? '118198167' : '118109824'
                    }.cms`}
                    alt="loop the loop"
                  />
                </figure>
              </div>
            </div>
          </>
        )}

        {/* Div added temporary for loop the loop section */}

        <div className={s.playNotes}>
          {translations?.howToPlayScreenTranslations && (
            <>{getHowToPlayInstructions()}</>
          )}
        </div>
      </div>
    </>
  );
};

HowToPlay.propTypes = {
  isMobile: PropTypes.bool,
  isAppView: PropTypes.bool,
};

HowToPlay.defaultProps = {
  isMobile: false,
  isAppView: false,
};

const mapStateToProps = state => ({
  gamesconfigData: _get(state, 'toigames.gamesconfig', ''),
  isMobile: state.isMobile,
});

export default connect(mapStateToProps)(HowToPlay);
